<template>
    <div class="store-category">
    <v-row>
      <v-col cols="12" md="8">
        <h1 class="text-left mx-4 mt-2">Store Category</h1>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn :to="{ name: 'AddStoreCategory' }" color="primary" class="mx-4 mt-2">Add Store Category</v-btn>
      </v-col>
    </v-row>

    <v-row>
        <v-col cols="12">
            <h2 v-if="!store_categories.length && !isLoading">No Fee Categories Found.</h2>
        </v-col>
        <v-col cols="12" md="4" v-for="category in store_categories" :key="category.id">
            <v-card
            class="mx-4"
            :to="{ name: 'EditStoreCategory', params: {id: category.id}}"
            >
                <v-card-title>{{ category.code }}</v-card-title>
                <v-card-subtitle class="text-left">{{ category.category_name }}</v-card-subtitle>
            </v-card>
        </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.visible">
      <span>{{ snackbar.text }}</span>
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import api from "@api/index";
import endpoints from "@api/repository";
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'StoreCategory',
    data(){
        return{
            store_categories: [],
            snackbar: {
                visible: false,
                text: "",
            },
        }
    },
    computed: {
        ...mapGetters(["currentUser", "accessToken", "isLoading"]),
        essentials() {
            return {
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        },
    },
    methods:{
        ...mapActions(["setLoading"]),
        
        async getAllStoreCategories(){
            this.store_categories = await api.call(this.essentials,endpoints.storeCategory);
        },

        // handles api errors
        async handleApiErrors(err) {
            this.setLoading(false);
            if (err.response) {
                console.log(err.response);
            } else {
                this.snackbar.text = "Unknown error occurred";
                this.snackbar.visible = true;
            }
        },
    },
    created(){
        this.getAllStoreCategories();
    }
}
</script>